var map = {
	"./404.vue": "8cdb",
	"./activation/index.vue": "38ce",
	"./mine/index.vue": "b5b1",
	"./trade/index.vue": "071d",
	"./user/createWallet/index.vue": "a010",
	"./user/forget/index.vue": "00db",
	"./user/login/index.vue": "9c2c",
	"./user/register/index.vue": "0de4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fbf";